<template>
    <div class="form-floating">
        <k-select
            v-model="selectedClasses"
            :disabled="disabled"
            :options="classes"
            :required="required"
            :multiple="multiple"
            :simplified="simplified"
            :allowSearch="allowSearch"
            :serverSideSearch="true"
            :show-tags="showTags"
            v-on="$listeners"
            v-on:search="searchQuery = $event"
            :showSelectedOptions="showSelectedOptions"
            :autoClose="autoClose"
            :error="error"
            :inline-dropdown="inlineDropdown"
            :label="localizedLabel"
            :placeholder="localizedPlaceholder"
            :selectedText="trans('general.classes.selected_classes')">
            <template #header v-if="bulkSelecting">
                <div class="form-check py-1 px-3">
                    <input class="form-check-input" type="checkbox" v-model="selectDeselectAll" id="selectDeselectAll">
                    <label class="form-check-label large" for="selectDeselectAll">
                        {{ trans('general.defaults.select_all') }}
                    </label>
                </div>
            </template>
        </k-select>
    </div>
</template>
<script>
import KSelect from "../molecules/KSelect.vue";
import BasicInput from "./BasicInput.vue";

export default {
    name: "ClassSelect",
    components: {BasicInput, KSelect},
    props: {
        value: Object | Array,
        multiple: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        label: {
            type: String
        },
        placeholder: {
            type: String,
        },
        error: {
            type: String,
            default: ''
        },
        page: Number,
        limit: Number,
        bulkSelecting: {
            type: Boolean,
            default: true
        },
        showTags: {
            type: Number,
            default: 0
        },
        allowSearch: {
            type: Boolean,
            default: false
        },
        showSelectedOptions: {
            type: Boolean,
            default: false
        },
        simplified: {
            type: Boolean,
            default: false
        },
        autoClose: {
            type: String,
            default: 'false'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        groupId: {
            type: Number,
            default: null
        },
        inlineDropdown: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        value: function () {
            this.selectedClasses = this.value;
        },
        selectedClasses: function () {
            this.$emit('input', this.selectedClasses);
            this.$emit('classesChanged', this.selectedClasses);
        },
        selectDeselectAll: function (trigger) {
            this.selectDeselect(trigger);
        },
        searchQuery: function () {
            this.load();
        }
    },
    computed: {
        localizedPlaceholder() {
            if (this.placeholder) {
                return this.placeholder;
            }

            return this.multiple ? trans('general.classes.select_rooms') : trans('general.classes.select_room');
        },
        localizedLabel() {
            if (this.label) {
                return this.label;
            }

            return this.multiple ? trans('general.classes.select_rooms') : trans('general.classes.select_room');
        }
    },
    data() {
        return {
            searchQuery: '',
            SELECT_PRIORITY: 'LEAF_PRIORITY',
            selectedClasses: [],
            classes: [],
            pageNum: this.page ?? 1,
            size: this.limit ?? 100,
            selectDeselectAll: true,
        }
    },
    methods: {
        load(selectAll = false) {
            axios.get(`/classes`, {params: {search: this.searchQuery, limit: this.size, page: this.pageNum}})
                .then((response) => {
                    const classes = response.data.data.data;
                    this.classes = classes.map((c) => ({id: c.id, label: c.name}));

                    if (selectAll) {
                        this.selectedClasses = this.classes;
                    }
                });
        },
        loadOne(groupId) {
            axios.get(`/classes/${groupId}`)
                .then((response) => {
                    const group = response.data.data;
                    this.selectedClasses = [{id: group.id, label: group.name}];
                });
        },
        getSelectedClasses() {
            return this.selectedClasses;
        },
        selectDeselect(trigger) {
            if (trigger) {
                this.selectedClasses = this.classes;
            } else {
                this.selectedClasses = [];
            }
        }
    },
    mounted() {
        if (this.groupId) {
            this.loadOne(this.groupId);
        } else {
            this.load(this.bulkSelecting);
        }
    }
}
</script>
